import api from "./axiosInstance";
import { toHttps } from "../utils/toHttps";

// Add Ad to Cart
export const addToCart = (formData) => {
  return api.post("/advertising/add-to-cart", formData);
};

// export const addToCart = (formData) => {
//     return api.post("/advertising/add-to-cart", formData, {
//         headers: {
//             "Content-Type": "multipart/form-data"
//         }
//     });
// };

// ✅ Get Cart Items by User ID
export const getCartByUserId = (userId) => {
  return api.get(`/advertising/cart/${userId}`);
};

// Get all successful ad images across all partners (for carousel/ads display)
export const getAllAdImages = () => {
  return api.get("/advertising/images").then((res) => {
    if (Array.isArray(res.data?.data)) {
      res.data.data = res.data.data.map((item) =>
        item?.image ? { ...item, image: toHttps(item.image) } : item
      );
    }
    return res;
  });
};

//Delete api to delete the pending subscriptions in the cart
export const deleteCartItem = (id, userName, userId) => {
  return api.delete(`/advertising/cart/${id}`, {
    data: { userName, userId },
  });
};

// ✅ Checkout Cart (pending → successful)
export const checkoutCartByUserId = (userId) => {
    return api.put(`/advertising/checkout/${userId}`);
};

// ✅ Get all successful subscriptions for a parent
export const getSubscriptionsByUserId = (userId) => {
    return api.get(`/advertising/subscriptions/${userId}`);
};

// ✅ Update campaignName and/or image for a subscription
export const updateSubscription = (id, formData) => {
    return api.put(`/advertising/subscriptions/${id}`, formData);
};

// ✅ Cancel a subscription (parent-initiated)
export const cancelSubscription = (id) => {
    return api.post(`/advertising/subscriptions/${id}/cancel`);
};
